// react
// components
import React from "react";

import { Avatar } from "@performyard/py-components";

import toEmployeeURL from "../../../utils/URLs/Employee";

import Link from "../../Link";
import Typography from "../../Text";

type UserBlockProps = {
	id?: string;
	name?: string;
};

const UserBlock = ({ id, name }: UserBlockProps) => {
	return (
		<div className="user-block" data-testid={`${name?.replace(/ /g, "-")}-user-block`}>
			<Avatar size={20} name={name || "User"} dangerouslySetClassName="user-image circle" id={id} />
			<div className="user-name">
				<Link href={toEmployeeURL(id)} forceHardReload={true}>
					<Typography weight="regular" size="paragraph-3">
						{name}
					</Typography>
				</Link>
			</div>
		</div>
	);
};

export default UserBlock;
